import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import styled from 'styled-components'
import { rem } from 'polished'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import FlashHotelAvailabilityButton from '../FlashHotel/FlashHotelMobileVariant/FlashHotelAvailabilityButton'
import OfferPageStickyFooter from '../OfferPageStickyFooter'
import MultiRoomSelectRoomsCtaButton from '../MultipleRoomsBooking/MultiRoomSelectRoomsCtaButton'
import type { AccommodationStickyFooterCtaMode } from './useMobilePackageSelectCtaExperimentState'

const StyledOfferPageStickyFooter = styled(OfferPageStickyFooter)`
  padding: ${rem(12)} ${rem(20)};
`
interface Props {
  offer: App.Offer
  checkInDate?: string
  ctaMode?: AccommodationStickyFooterCtaMode
  firstAvailableDuration?: number
  shouldSkipDurationStep?: boolean
}

function AccommodationOfferPageStickyFooter(props: Props) {
  const {
    checkInDate,
    offer,
    ctaMode = 'checkAvailability',
    firstAvailableDuration,
    shouldSkipDurationStep,
  } = props

  const callToAction = ctaMode === 'selectRooms' ? (
    <MultiRoomSelectRoomsCtaButton
      checkIn={checkInDate}
      firstAvailableDuration={firstAvailableDuration}
      shouldSkipDurationStep={shouldSkipDurationStep}
      size="large"
      fit="full-width"
    />
  ) : (
    <FlashHotelAvailabilityButton
      size="large"
      fit="full-width"
      allowViewOptions={ctaMode === 'selectRoom' || ctaMode === 'selectPackage'}
    />
  )

  return (
    <StyledOfferPageStickyFooter
      visible
      callToActionDisabled
      offer={offer}
    >
      <SoftOfferPageWalledGarden>
        {callToAction}
      </SoftOfferPageWalledGarden>
    </StyledOfferPageStickyFooter>
  )
}

export default withOfferPageAndReduxState((state) => ({
  offer: state.offer,
  checkInDate: state.checkInDate,
}), AccommodationOfferPageStickyFooter)
